import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CookieIcon, HomeIcon, PaletteIcon, CameraIcon, BriefcaseIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { EASY_CARDS } from './salesData';
const ICONS = [CookieIcon, BookOpenIcon, HomeIcon, PaletteIcon, CameraIcon, BriefcaseIcon];

/**
 * FACILIDAD. Responde la primera objeción del visitante que llega del anuncio:
 * "esto no es para mí porque no sé hacerlo".
 */
export function EasySection() {
  return <section className="bg-cream py-14 sm:py-20" aria-labelledby="easy-title" data-id="element-114" data-mp="2qgc49xstn6q8">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-115" data-mp="2v7kf8y9sv05i">
        <div className="max-w-3xl" data-id="element-116" data-mp="2va6vdmaranzc">
          <SectionTag data-id="element-117" data-mp="2za79f5ty0x5v">Sin experiencia previa</SectionTag>
          <h2 id="easy-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-118" data-mp="2zbs54yrzum5b">
            No necesitás ser experto en repostería
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-119" data-mp="2w4giooe1uhsn">
            Aunque nunca hayas preparado New York Cookies, vas a poder avanzar siguiendo recetas
            organizadas paso a paso. El objetivo es ayudarte a conseguir esas cookies que llaman la
            atención desde el primer vistazo: grandes, gruesas, llenas de sabor y con combinaciones
            que dan ganas de probar.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3" data-id="element-120" data-mp="3eto9fsowrl23">
          {EASY_CARDS.map((card, index) => {
          const Icon = ICONS[index] ?? CookieIcon;
          return <motion.li key={card.id} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(index, 5) * 0.035
          }} className="flex h-full flex-col rounded-4xl bg-ivory p-5 shadow-bakery-sm sm:p-6" data-id="element-121" data-mp="361335c2gr6u5" data-mpi={index}>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-caramel-pale" aria-hidden data-id="element-122" data-mp="lhnyczqbbbv4">
                  <Icon className="h-5 w-5 text-[#F47A2A]" data-id="element-123" data-mp="brb7yqvtgoh2" />
                </span>
                <h3 className="mt-4 font-display text-[1.02rem] leading-tight text-charcoal sm:text-[1.15rem]" data-id="element-124" data-mp="3txg4hqn3vzld">
                  {card.title}
                </h3>
                <p className="mt-2 font-sans text-[0.86rem] leading-relaxed text-charcoal-mid" data-id="element-125" data-mp="2pbq5wcz9gd2">
                  {card.body}
                </p>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}